import { DateTime } from "luxon";
import { useEffect, useState } from "react";
import { getPublicTransportImportTypeLabel, PublicTransportImportType } from "../../../../constant/PublicTransportImportType";
import { usePublicTransportService } from "../../../../hooks";
import {
  TableColumn,
  TableDataType,
} from "../../../../types/Table/TableColumns";
import SortableTable from "../../../Table/SortableTable";
import { TableAction } from "../../../Table/TableAction";
import { useNavigate } from "react-router-dom";
import { getPublicTransportDownloadStatusLabel } from "../../../../constant/PublicTransportDownloadStatus";

const DownloadTable = () => {
  const publicTransportService = usePublicTransportService();
  const [downloads, setDownloads] = useState([]);
  const navigate = useNavigate();

  useEffect(() => {
    publicTransportService.GetDownloads().then((data) => {
      setDownloads(data);
    });
  }, []);

  const viewDownload = (item: any) => {
    navigate("/admin/layers/Basemap:PublicTransport/downloads/" + item.publicTransportDownloadId);
  }

  const cols: TableColumn[] = [
    {
      displayName: "Source",
      field: "publicTransportImportType",
      sortable: false,
      renderContents: (value: any, downloadSource: any) => {
        const label = getPublicTransportImportTypeLabel(value);
        return <a onClick={() => viewDownload(downloadSource)} href="#">{label}</a>;
      }
    },
    {
      displayName: "Quarter",
      field: "downloadQuarter",
      sortable: true,
    },
    {
      displayName: "Download Start Date",
      field: "downloadDate",
      sortable: false,
      dataType: TableDataType.DATE,
      dateFormat: "dd/MM/yyyy HH:mm",
    },
    {
      displayName: "Duration",
      field: "duration",
      sortable: false,
      renderContents: (value: any) => {
        if (!value) return "N/A";
        var timeVals = parseLuxonDuration(value);
        return `${timeVals.hours}h ${timeVals.minutes}m ${timeVals.seconds}s`;
      },
    },
    {
      displayName: "Status",
      field: "downloadStatus",
      sortable: false,
      renderContents: (value: any) => getPublicTransportDownloadStatusLabel(value),
    },
    {
      displayName: "Failure Reason",
      field: "failureReason",
      sortable: false
    }
  ];

  const parseLuxonDuration = (luxonDate: DateTime) => {
    const hours = luxonDate.hour;
    const minutes = luxonDate.minute;
    const seconds = luxonDate.second;

    return {
      hours,
      minutes,
      seconds,
    };
  };

  return (
    <>
      <SortableTable columns={cols} data={downloads} />
    </>
  );
};

export default DownloadTable;
